import {stateData, reduxState} from '../../values';

const initialState = {
    apps:           [],
    status:         stateData.state1,
    appsEdit:       [],
    records:        1
};

const reducer = (state=initialState, action) =>{
    if(action.type === reduxState.get_apps){
        return {
            ...state,
            apps:     action.payload,
            status:     action.status,
            records:    action.records
        }
    }
    if(action.type === reduxState.update_apps){
        return {
            ...state,
            appsEdit: action.payload
        }
    }
    return state
}
export default reducer